/**
 * Enum for sku status
 * @readonly
 * @enum {String}
 */
export const SKU_STATUS = Object.freeze({
	ACTIVE: 'active',
	INACTIVE: 'inactive',
	EOL: 'eol',
});

/**
 * Enum for sku status color
 * @readonly
 * @enum {String}
 */
export const SKU_STATUS_COLOR = Object.freeze({
	[SKU_STATUS.ACTIVE]: 'success',
	[SKU_STATUS.INACTIVE]: 'alert',
	[SKU_STATUS.EOL]: 'alto',
});

/**
 * Enum for sku status title
 * @readonly
 * @enum {String}
 */
export const SKU_STATUS_TITLE = Object.freeze({
	[SKU_STATUS.ACTIVE]: 'Active',
	[SKU_STATUS.INACTIVE]: 'Inactive',
	[SKU_STATUS.EOL]: 'EOL',
});

/**
 * Enum for sku status options
 * @readonly
 * @enum {String}
 */
export const SKU_STATUS_OPTIONS = Object.freeze([
	{
		name: 'All status',
		value: null,
	},
	{
		name: SKU_STATUS_TITLE[SKU_STATUS.ACTIVE],
		value: SKU_STATUS.ACTIVE,
	},
	{
		name: SKU_STATUS_TITLE[SKU_STATUS.INACTIVE],
		value: SKU_STATUS.INACTIVE,
	},
	{
		name: SKU_STATUS_TITLE[SKU_STATUS.EOL],
		value: SKU_STATUS.EOL,
	},
]);

/**
 * Enum for sku type
 * @readonly
 * @enum {String}
 */
export const SKU_TYPE = Object.freeze({
	NORMAL: 'normal',
	FREEBIE: 'freebie',
});

/**
 * Enum for sku type title
 * @readonly
 * @enum {String}
 */
export const SKU_TYPE_TITLE = Object.freeze({
	[SKU_TYPE.NORMAL]: 'Normal',
	[SKU_TYPE.FREEBIE]: 'Freebie',
});

/**
 * Enum for sku type options
 * @readonly
 * @enum {String}
 */
export const SKU_TYPE_OPTIONS = Object.freeze([
	{
		name: 'All product types',
		value: null,
	},
	{
		name: SKU_TYPE_TITLE[SKU_TYPE.NORMAL],
		value: SKU_TYPE.NORMAL,
	},
	{
		name: SKU_TYPE_TITLE[SKU_TYPE.FREEBIE],
		value: SKU_TYPE.FREEBIE,
	},
]);
